import React from "react";

export interface featureFlagStrategyInterface {
	entity_list_id: string;
	environment_for_strategy: string[];
	strategy_type: string;
}

export interface featureFlagInterface {
	name: string;
	status: boolean;
	strategies: featureFlagStrategyInterface[];
}

export interface featureFlagProjectEnvironmentInterface {
	name: string;
	id: string;
}

export interface featureFlagEntityListInterface {
	entity_ids: string[];
	entity_type: string;
	id: string;
	name: string;
}

export interface featureFlagProjectInterface {
	entity_lists: featureFlagEntityListInterface[];
	valid_environments_for_project: featureFlagProjectEnvironmentInterface[];
}

export interface flagsProviderDataInterface {
	featureFlagsList: Record<string, featureFlagInterface>;
	featureFlagsProjectData: featureFlagProjectInterface;
}

const flagsProviderData: flagsProviderDataInterface = {
	featureFlagsList: {
		name: {
			name: "",
			status: false,
			strategies: []
		}
	},
	featureFlagsProjectData: {
		entity_lists: [],
		valid_environments_for_project: []
	}
};

export const FlagsContext = React.createContext(flagsProviderData);
